'use strict'

import { axiosPost } from '../../axios/axios.js'

export function getServiceObjectCheckResult (serviceObjectId, checkRecentRequests) {
  return getServiceObjectsCheckResult.call(this, [serviceObjectId], checkRecentRequests)
}

export function getServiceObjectsCheckResult (serviceObjectsIds, checkRecentRequests) {
  const bodyFormData = new FormData()
  bodyFormData.set('ids', serviceObjectsIds.join(','))
  if (checkRecentRequests) {
    bodyFormData.set('checkRecentRequests', checkRecentRequests)
  }
  return getServiceObjectsCheckResultInner.call(this, '/service/delta/serviceobject/checkObjectsBeforeRequestsCreation', bodyFormData)
}

export function getAuditRequestServiceObjectCheckResult (requestId) {
  return getAuditRequestsServiceObjectsCheckResult.call(this, [requestId])
}

export function getAuditRequestsServiceObjectsCheckResult (requestsIds) {
  const bodyFormData = new FormData()
  bodyFormData.set('requestIds', requestsIds.join(','))
  return getServiceObjectsCheckResultInner.call(this, '/service/delta/serviceobject/checkObjectsBeforeRequestsAudit', bodyFormData)
}

function getServiceObjectsCheckResultInner (url, bodyFormData) {
  this.$q.loading.show({ spinnerColor: 'blue-11' })
  return axiosPost({
    url: url,
    data: bodyFormData,
    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
    onSuccess: (response) => {
      this.$q.loading.hide()

      return new Promise((resolve, reject) => {
        const data = response.data

        const warnings = []
        addServiceObjectsStateWarning(warnings, data.dismantledObjects, 'Демонтирован')
        addServiceObjectsStateWarning(warnings, data.reconstructionObjects, 'Реконструкция')
        addServiceObjectsStateWarning(warnings, data.constructionObjects, 'Строительство')

        if (data.withRecentRequestsObjects && data.withRecentRequestsObjects.length) {
          warnings.push('На ' + data.withRecentRequestsObjects.join(', ') + ' уже была создана внутренняя заявка в течение 30 календарных дней.')
        }

        if (warnings.length) {
          const question = data.total > 1 ? 'Заводить заявки?' : 'Заводить заявку?'
          warnings.push(question)
          this.$d_ask({
            callback: (askData, action) => {
              data.continueAction = action === 'yes'
              resolve(data)
            },
            // warning: warnings.join('\n') + '\n\n' + question,
            warning: warnings,
            buttons: [
              { key: 'yes', name: 'Да', color: 'red' },
              { key: 'no', name: 'Нет', color: 'blue' }
            ]
          })
        } else {
          data.continueAction = true
          resolve(data)
        }
      })
    },
    onFailure: (response) => {
      this.$q.loading.hide()

      this.$q.notify({
        type: 'negative',
        message: response.message || 'Ошибка загрузки информации по выбранным объектам обслуживания',
        progress: true,
        timeout: 8000
      })
      return { continueAction: false }
    }
  })
}

function addServiceObjectsStateWarning (warnings, objectNames, stateName) {
  if (objectNames && objectNames.length) {
    warnings.push('Статус ' + objectNames.join(', ') + ' - ' + stateName + '.')
  }
}
